<template>
  <div class="post-likeheart grid">
    <feather-icon
      class="mr-2 groups_like_icon"
      icon="ThumbsUpIcon"
      v-if="!isLiked"
      @mouseenter="likeemoji = true"
    ></feather-icon>
    <div class="flex items-center cursor-pointer" @click="handleLike('')">
      <img :src="likeTypeImage" class="mr-2 h-5" v-if="isLiked" />
    </div>
    <div class="cust-likesbox" v-if="likeemoji">
      <div
        class="cust-hoverLike"
        @mouseenter="likeemoji = true"
        @mouseleave="likeemoji = false"
      >
        <a class="Like__link js-hover"></a>
        <div class="cust-likesemojiparent">
          <div
            v-for="(reaction, index) in reactions"
            :key="'-reaction-' + index"
            class="cust-likesemoji"
            :class="reaction.emoji"
            @click="handleLike(reaction.type)"
          >
            <!-- <div class="cust-likiesicon" :class="reaction.icon"></div> -->
            <div class="">
              <img :src="reaction.img" class="p-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    postId: {
      type: String,
      required: true,
    },
    isLiked: {
      type: Boolean,
      required: true,
    },
    likeType: {
      type: String,
    },
  },
  data() {
    return {
      likeemoji: false,
      reactions: [
        {
          type: "like",
          emoji: "Emoji--like",
          icon: "icon--like",
          img: require("../img/thumb.jpg"),
        },
        {
          type: "celebrate",
          emoji: "Emoji--sad",
          icon: "icon--sad",
          img: require("../img/clapping.jpg"),
        },
        {
          type: "support",
          emoji: "Emoji--angry",
          icon: "icon--angry",
          img: require("../img/support.jpg"),
        },
        {
          type: "love",
          emoji: "Emoji--love",
          icon: "icon--heart",
          img: require("../img/heart.jpg"),
        },
        {
          type: "insightful",
          emoji: "Emoji--haha",
          icon: "icon--haha",
          img: require("../img/lamp.jpg"),
        },
        {
          type: "curios",
          emoji: "Emoji--wow",
          icon: "icon--wow",
          img: require("../img/curios.jpg"),
        },
      ],
    };
  },
  computed: {
    likeTypeImage() {
      return this.reactions.find((x) => x.type === this.likeType).img;
    },
  },
  methods: {
    handleLike(type) {
      if (this.isLiked) {
        this.unlikePost();
      } else {
        this.likePost(type);
      }
    },
    async likePost(type) {
      let loader = this.$loading();
      try {
        const payload = {
          type: type,
          postId: this.postId,
        };

        await this.$store.dispatch("posts/likePost", payload);

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async unlikePost() {
      let loader = this.$loading();
      try {
        const payload = {
          postId: this.postId,
        };

        await this.$store.dispatch("posts/unlikePost", payload);

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async likeUnlikePost(postId, isLiked) {
      let loader = this.$loading();
      try {
        if (isLiked) {
          let unLike = {
            postId: postId,
          };

          await this.$store.dispatch("posts/unlikePost", unLike);
        } else {
          let Like = {
            type: "like",
            postId: postId,
          };

          await this.$store.dispatch("posts/likePost", Like);
        }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../scss/PostLike.scss";
</style>
